module.exports = __webpack_public_path__ + "img/recharge_log.1c868218.png";